/** Shared-clock animation time. Pausing/parking keeps the pose; a seek resets
 * the baseline instead of replaying hours of packets or jumping the camera. */
export class AnimationTime {
  private previous: number | null = null;
  private elapsed = 0;
  get milliseconds(): number {
    return this.elapsed;
  }

  /** Resume from the held pose without accumulating time while unrendered. */
  resetBaseline(): void {
    this.previous = null;
  }

  sample(now: number, paused: boolean): number {
    if (this.previous !== null && !paused) {
      const delta = now - this.previous;
      if (delta >= 0 && delta < 60_000) this.elapsed += delta;
    }
    this.previous = now;
    return this.elapsed;
  }
}
